import { useState } from 'react';
import logoImg from '../assets/logo_with_name.png';
import { trackMenuOpen, trackMenuClose, trackMenuLinkClick } from '../analytics';

const LINKS = [
  { label: 'PHILOSOPHY', href: '#philosophy' },
  { label: 'SERVICES',   href: '#services'   },
  { label: 'PROCESS',    href: '#process'    },
  { label: 'WORK',       href: '#work'       },
  { label: 'CONTACT',    href: '#contact'    },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
    trackMenuClose();
  };

  return (
    <>
      <nav className="v-nav">
        <a href="#top" style={{ lineHeight: 0 }} onClick={close}>
          <img src={logoImg} alt="veremeen" className="v-nav__logo" />
        </a>
        <button
          className="v-nav__menu"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => {
            const next = !open;
            setOpen(next);
            next ? trackMenuOpen() : trackMenuClose();
          }}
        >
          <span>{open ? 'CLOSE' : 'MENU'}</span>
          <div className={`v-nav__lines${open ? ' v-nav__lines--open' : ''}`}>
            <span />
            <span />
          </div>
        </button>
      </nav>

      <div className={`v-menu-overlay${open ? ' v-menu-overlay--open' : ''}`} aria-hidden={!open}>
        <nav className="v-menu-overlay__nav">
          {LINKS.map(({ label, href }) => (
            <a
              key={href}
              href={href}
              className="v-menu-overlay__link"
              onClick={() => { trackMenuLinkClick(label); close(); }}
            >
              {label}
            </a>
          ))}
        </nav>
        <a href="mailto:hello@veremeen.com" className="v-menu-overlay__email">
          hello@veremeen.com
        </a>
      </div>
    </>
  );
}
